import { render, staticRenderFns } from "./SupplierOrderList.vue?vue&type=template&id=24896f9a&scoped=true&"
import script from "./SupplierOrderList.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderList.vue?vue&type=style&index=0&id=24896f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24896f9a",
  null
  
)

export default component.exports